import { POWER_USER_EXTENSION_URL } from "../workspaceOverview/constants";

// The two Quick Start pages; /quickstart picks one (see quickstartEntry).
export const EXTENSION_QUICKSTART_PATH = "/quickstart/extension";
// The workspace (Altimate Code) Quick Start, which explains workspaces before
// the wizard asks for anything.
export const WORKSPACE_QUICKSTART_PATH = "/quickstart/workspaces";

export const VSCODE_MARKETPLACE_URL = POWER_USER_EXTENSION_URL;
export const POWER_USER_DOCS_URL = "https://help.altimate.ai/dbt-power-user/";
export const API_KEY_SETTINGS_PATH = "/settings/api-key";

// The open demo lives in the URL (`?demo=lineage`), so a link can open one
// directly; unknown values are ignored.
export const DEMO_PARAM = "demo";

export interface ExtensionDemo {
  id: "lineage" | "preview" | "autocomplete" | "docs" | "health" | "explain";
  label: string;
  src: string;
}

// The Supademo walkthroughs the legacy Power User quickstart embeds, in the
// order the demo dialog lists them.
export const EXTENSION_DEMOS: ExtensionDemo[] = [
  {
    id: "lineage",
    label: "Column lineage",
    src: "https://app.supademo.com/embed/clncl1wuj44z8pezp7iw9vnj5",
  },
  {
    id: "preview",
    label: "Query preview",
    src: "https://app.supademo.com/embed/S4uCGtgs_jisbJs5SfJzZ",
  },
  {
    id: "autocomplete",
    label: "Auto-complete",
    src: "https://app.supademo.com/embed/clncaqx253xyypezplang48gr",
  },
  {
    id: "docs",
    label: "Docs generation",
    src: "https://app.supademo.com/embed/clncbea4j3yl1pezp0zp0pfys",
  },
  {
    id: "health",
    label: "Health check",
    src: "https://app.supademo.com/embed/clof2pnhl262fpegd7straszw",
  },
  {
    id: "explain",
    label: "Query explanation",
    src: "https://app.supademo.com/embed/clog0tipl3n35pegdy28pxe06",
  },
];

export const findDemo = (id: string | null) => EXTENSION_DEMOS.find(demo => demo.id === id);
